module.exports = __webpack_public_path__ + "img/stroke.21da4222.png";